import React from 'react';
type StatusBadgeProps = {
  status: string;
};
export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status
}) => {
  let bgColor = 'bg-gray-100';
  let textColor = 'text-gray-800';
  const s = status.toLowerCase();
  if (s === 'completed' || s === 'active' || s === 'approved') {
    bgColor = 'bg-brand-primary-light/30';
    textColor = 'text-brand-primary-dark';
  } else if (s === 'pending' || s === 'in progress') {
    bgColor = 'bg-brand-warning/20';
    textColor = 'text-brand-warning';
  } else if (s === 'failed' || s === 'expired') {
    bgColor = 'bg-brand-error/10';
    textColor = 'text-brand-error';
  }
  return <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${bgColor} ${textColor}`} data-id="element-330">
      {status}
    </span>;
};